import React from 'react';
import CircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress';
import { makeStyles, createStyles, withStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'relative',
    },
    bottom: {
      color: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    top: {
      color: '#1a90ff',
      position: 'absolute',
      left: 0,
    },
    circle: {
      strokeLinecap: 'round',
    },
  }),
);

export function CircularProgressWithLabel(props: CircularProgressProps & { value: number, children: React.ReactNode, bottom?: string, top?:string }) {
  const classes = useStyles();
  
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress variant="static" className={props.bottom ? props.bottom : classes.bottom} {...props} value={100} />
      <CircularProgress variant="static" classes={{circle:classes.circle}} className={props.top ? props.top : classes.top} {...props}  />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="caption" component="div" color="textSecondary">{props.children}</Typography>
      </Box>
    </Box>
  );
}